import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import AddButton from "../../AdminPanel/Component/UI/AddButton";
import CommonTableTeamUsers from "../../AdminPanel/Component/UI/CommonTableTeamUsers";
import Tooltip from "../../AdminPanel/Component/UI/Tooltip";
import SearchBox from "../../AdminPanel/Component/UI/SearchBox";
import AddTeamMembers from "./Component/AddTeamMembers";
import CompareTeamMembers from "./Component/CompareTeamMembers";
import { MdSearch, MdOutlineClose, MdArrowForwardIos, MdOutlineArrowBack, MdArrowBackIos } from "react-icons/md";
import { HiOutlineHome, HiMiniPlus, HiMiniMinus } from "react-icons/hi2";
import { AiOutlineFileText } from "react-icons/ai";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { assessmentActions, questionsActions, userActions } from "../../../_actions";
import RemoveTeamMember from "./Component/RemoveTeamMember";
import moment from 'moment';
import UpdateUserModal from "../MyUsers/Component/UpdateUserModal";
import { TbReportAnalytics } from "react-icons/tb";

import AssessmentReport from "../../Surveylink/Component/AssessmentReport/AssessmentReport";
import AssessmentSummary from "../../Surveylink/Component/AssessmentSummary/AssessmentSummary";
import AssessmentManagerReport from "../../Surveylink/Component/AssessmentManagerReport/AssessmentManagerReport";
import AssessmentHiringReport from "../../Surveylink/Component/AssessmentHiringReport/AssessmentHiringReport";

import { MdClose } from "react-icons/md";
import StatsCard from "../../AdminPanel/Component/UI/StatsCard";

import { LuUsers, LuUserCheck, LuDownload } from "react-icons/lu";
import { SlReload } from "react-icons/sl";


class AdminPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showRemoveConfirmId: "",
      crrTeamId: this.props.match.params.id,
      addTeamMemberModal: false,
      compareTeamMemberModal: false,
      updateUserModal: false,
      entries: 20,
      updateForm: {
        id: "",
        name: "",
        email: "",
        mobile: ""
      },
      pageNo: 1,
      size: 10,
      keyWord: "",
      compareEditable: false,
      compareUserList: [],
      tabName: "All",
      surveyLanguageCode: 'en',
      crrEmpDetails: {
        "name": "",
        "emp_id": ""
      }
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAssessmentColorCode());

    const temp = {
      teamId: this.state.crrTeamId,
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.getMyUserList(temp));
    this.props.dispatch(assessmentActions.getMyUserStatus({
      teamId: this.state.crrTeamId
    }));


    const tempX1 = {
      id: this.state.crrTeamId
    }
    this.props.dispatch(assessmentActions.getTeamDetails(tempX1));


    const tempX = {
      teamId: "NA",
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.getMyUserTeamList(tempX));

    const tempTeam = {
      keyWord: "",
      pageNo: 1,
      size: 1
    }
    this.props.dispatch(assessmentActions.getTeamList(tempTeam));
    this.callUserListAPI();
  }

  callUserListAPI = () => {
    const { pageNo, size, keyWord } = this.state;
    this.props.dispatch(
      assessmentActions.getMyUserList({
        pageNo,
        size,
        keyWord,
        teamId: this.state.crrTeamId,
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.pageNo !== this.state.pageNo ||
      prevState.size !== this.state.size ||
      prevState.keyWord !== this.state.keyWord
    ) {
      this.callUserListAPI();
    }
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getMyUserList(data));
  }

  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getMyUserListTotal } = this.props.assessment;
    const totalPages = Math.ceil(getMyUserListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };

  openAddTeamMemberModal = () => {
    console.log("Opening Add User Modal");
    this.setState({ addTeamMemberModal: true }, () => {
      console.log("Modal state updated:", this.state.addTeamMemberModal);

    });
  };

  onCompareUserSelect = () => {
    this.setState({ compareEditable: true });
  }
  closeCompareUserSelect = () => {
    this.setState({ compareEditable: false, compareUserList: [] });
  }
  selectCompareRow = (row) => {
    this.setState((prevState) => {
      const exists = prevState.compareUserList.some(
        (item) => item.userId === row.userId
      );

      return {
        compareUserList: exists
          ? prevState.compareUserList.filter(
            (item) => item.userId !== row.userId
          )
          : [
            ...prevState.compareUserList,
            { userId: row.userId, name: row.name }
          ]
      };
    });
  };
  openCompareTeamMemberModal = () => {
    let { compareUserList, crrTeamId } = this.state;
    const tempData = {
      "teamId": crrTeamId,
      "userList": compareUserList.map((ele) => (ele.userId)),
      "isAll": true
    }
    this.props.dispatch(assessmentActions.getAllUserAssessmentByTeamId(tempData));
    this.setState({ compareTeamMemberModal: true });
  };

  closeCompareTeamMembersModal = () => {
    console.log("Closing Compare User Modal");
    this.setState({ compareTeamMemberModal: false });
  };

  closeAddTeamMembersModal = () => {
    console.log("Closing Add User Modal");
    this.setState({ addTeamMemberModal: false });
  };

  // Handle entries dropdown change
  handleEntriesChange = (value) => {
    this.setState({ entries: value });
  };

  onAddUser = (data) => {
    console.log("data--------///------->", data)
    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.createNewTeam(data, temp));
    this.closeAddTeamMembersModal();
  };

  goBack = () => {
    this.props.history.push(`/assessment/myteams`);
  }

  onAddTeamMember = (list) => {
    const data = {
      id: this.state.crrTeamId,
      userList: list
    }
    const temp = {
      teamId: this.state.crrTeamId,
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    console.log("data------------------>", data)
    this.props.dispatch(assessmentActions.updateTeamMembers(data, temp));
    this.closeAddTeamMembersModal();
  }

  // Open delete modal
  onRemoveConfirm = (row) => {
    this.setState({ showRemoveConfirmId: row.userId });
  };

  // Close delete modal
  closeDeleteConfirm = () => {
    this.setState({ showRemoveConfirmId: "" });
  };

  // submit delete modal
  submitDeleteConfirm = () => {
    let data = {
      id: this.state.showRemoveConfirmId
    }
    const temp = {
      teamId: this.state.crrTeamId,
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.deleteTeamMember(data, temp));
    this.closeDeleteConfirm();
  };

  handleUpdateChange = (e) => {
    let { updateForm } = this.state;
    updateForm[e.target.name] = e.target.value;
    this.setState({ updateForm });
  }

  closeUpdateUserModal = () => {
    this.setState({ updateUserModal: false });
  };

  onEditUser = (data) => {
    let temp = {
      id: data.userId,
      name: data.name,
      email: data.email,
      mobile: data.mobile
    }
    this.setState({ updateForm: temp, updateUserModal: true });
  }

  onUpdateUser = (data) => {
    const temp = {
      teamId: this.state.crrTeamId,
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.updateMyUser({ ...data, mobile: data && data.mobile ? data.mobile.toString() : null }, temp, "TeamDetails"));
    this.closeUpdateUserModal();
  };
  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };
  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };


  onReportModal = (ele) => {
    let data = {
      employeeId: ele.employeeId
    }
    this.props.dispatch(questionsActions.getAssessmentReportAdmin(data));


    this.setState({
      crrEmpDetails: {
        name: ele.name,
        emp_id: ele.employeeId
      },
      showReportModal: true,
      showSummaryReport: false,
      showManagerReportModal: false,
      showHiringReportModal: false
    });
  }

  closeModal = () => {
    this.setState({
      showReportModal: false,
      showSummaryReport: false,
      showManagerReportModal: false,
      showHiringReportModal: false
    });
  }

  render() {
    let { assessment, questions } = this.props;
    let { crrEmpDetails,
      showReportModal, showSummaryReport, showManagerReportModal, showHiringReportModal,
      surveyLanguageCode,
      tabName, compareUserList, compareEditable, showRemoveConfirmId, pageNo, size, crrTeamId, updateUserModal } = this.state;
    let { getMyUserStatusData, getAssessmentColorCodeData, getAllUserAssessmentByTeamIdData, getMyUserTeamListData, getMyUserTeamListTotal, getTeamListData,
      userAssessmentUserProfileData, getMyUserListData, getMyUserListTotal, getTeamDetailsData } = assessment;
    let { getAssessmentReportByEmpIDData, getTranslateElementAllData, getTalentPlusEmpAdminStatusData } = questions;
    const teamName = getTeamDetailsData?.name ?? "";

    let loading = assessment.loading || questions.loading;

    let createdAt = getTalentPlusEmpAdminStatusData && getTalentPlusEmpAdminStatusData.createdAt
      ? moment(getTalentPlusEmpAdminStatusData.createdAt)
        .utcOffset("+05:30")
        .format("DD MMMM, YYYY")
      : "";



    function themesList(ele) {
      const list = Object.entries(
        ele?.themes && typeof ele.themes === "object" ? ele.themes : {}
      )
        .sort(([a], [b]) => {
          const na = parseInt(a.replace(/\D/g, ""), 10);
          const nb = parseInt(b.replace(/\D/g, ""), 10);
          return (isNaN(na) ? 999 : na) - (isNaN(nb) ? 999 : nb);
        })
        .slice(0, 5)
        .map(([_, value], index) => ({
          name: typeof value === "string" ? value : String(value ?? ""),
          colorcode: "#212121",
          bgcolor: "#F5F5F5",
          rank: index + 1
        }))
      return list && list.length > 0 ? list : []
    }


    function getFilterList(value, list) {
      if (value === "All") {
        return list;
      } else if (value === "Completed") {
        return list.filter(item => item.isComplete === true);
      } else if (value === "Not Started") {
        return list.filter(item => item.isClicked === false);
      } else if (value === "In Progress") {
        return list.filter(item => item.isComplete === false && item.isClicked === true);
      }

      return list
    }

    console.log("getMyUserStatusData--->", getMyUserStatusData)

    const x = getMyUserStatusData?.[0] || {};
    const total = Number(x.total) || 0;
    const completed = Number(x.completed) || 0;
    const status = {
      total,
      completed,
      clicked: total - completed
    };

    console.log("getMyUserStatusData--->", getMyUserStatusData)

    let data = getMyUserListData && getMyUserListData.length > 0 ? getFilterList(tabName, getMyUserListData).map((ele, i) => ({
      id: i + 1,
      userId: ele.id,
      employeeId: ele.employeeId,
      name: ele.name,
      email: ele.email,
      themes: themesList(ele),
      status: ele.isComplete ? "Completed" : (ele.isClicked ? "Pending" : "Not Started")
    })) : [];


    const { addTeamMemberModal, compareTeamMemberModal, entries } = this.state;

    const columns = [
      { key: "id", label: "S.No." },
      { key: "name", label: "Name" },
      { key: "email", label: "Email Address" },
      { key: "themes", label: "Dominant Themes (Rank 1 to 5)" },
      { key: "status", label: "Status" }
    ];

    const start = getMyUserTeamListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getMyUserTeamListTotal);
    const totalPages = Math.ceil(getMyUserTeamListTotal / size);

    const getPeriod = () => {
      const hour = moment().hour(); // 0-23
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };


    function getDimensionCodeCode(dimension) {
      let colorCode = "#757575";
      if (getAssessmentColorCodeData && getAssessmentColorCodeData.length > 0) {
        let getIndex = getAssessmentColorCodeData.findIndex(prev => prev.parameterDimensionName === dimension);
        if (getIndex !== -1) {
          colorCode = getAssessmentColorCodeData[getIndex]["colorCode"]
        }
      }
      return colorCode ? colorCode : "#757575"
    }



    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (
          getTranslateElementAllData &&
          getTranslateElementAllData.length > 0
        ) {
          let getIndex = getTranslateElementAllData.findIndex(
            (prev) => prev.name === name
          );
          if (getIndex !== -1) {
            sentence =
              getTranslateElementAllData &&
                getTranslateElementAllData[getIndex] &&
                getTranslateElementAllData[getIndex]["transl"] &&
                getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode]
                ? getTranslateElementAllData[getIndex]["transl"][
                surveyLanguageCode
                ]
                : "";
          }
        }
        console.log("sentence------------>", sentence);
        console.log("surveyLanguageCode------------>", surveyLanguageCode);
        console.log(
          "getTranslateElementAllData------------>",
          getTranslateElementAllData
        );

        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence =
          element &&
            element["details"] &&
            element["details"]["transl"] &&
            element["details"]["transl"][surveyLanguageCode] &&
            element["details"]["transl"][surveyLanguageCode][name]
            ? element["details"]["transl"][surveyLanguageCode][name]
            : "";
        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    function EditButtonFn(name, text) {
      return <>{GetTextByLanguage(name, text)}</>;
    }
    function EditDetailsFn(element, name, text) {
      return <>{GetDetailsByLanguage(element, name, text)}</>;
    }




    return (
      <>
        <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
          <div className="space-y-6 p-8">
            {/* Header Row */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex items-center space-x-3">
                  <div className="bg-white hover:text-[#1976D2] textblack border border-[#D1D5DB] p-1.5 rounded-full cursor-pointer" onClick={() => this.goBack()}>
                    <MdOutlineArrowBack size={26} className="inline-block" />
                  </div>
                  <Heading className="text-xl" title={teamName || "NA"} />
                </div>
                <div className="h-6 w-[1px] bg-gray-300" />
                <span className="text-sm textblack flex items-center gap-2">
                  <span className="textblack"><HiOutlineHome size={22} /></span>
                  <span className="textblack"><MdArrowForwardIos size={16} /></span>
                  <span className="textblack">Team Members</span>
                </span>
              </div>

              <div className="flex items-center gap-3">
                {compareEditable ?
                  <AddButton title="Close Compare" Icon={MdOutlineClose} className="bg-white border border-red-200 text-red-600" onClick={this.closeCompareUserSelect} />
                  :
                  <AddButton title="Compare Themes" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.onCompareUserSelect} />
                }

                {/* <button className="flex items-center py-2 px-4 text-sm border border-[#D9D9D9] rounded-md font-medium text-[#212121] w-full md:w-auto">
                  <span className="mr-2">
                    <LuDownload size={20} />
                  </span>
                  Download CSV
                </button> */}


                <AddButton title="Add Members" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.openAddTeamMemberModal} />
              </div>
            </div>

            {/* Stats Section*/}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <StatsCard icon={LuUsers} label="Total Teams" value={status.total || 0} />
              <StatsCard icon={SlReload} label="Pending" value={status.clicked || 0} />
              <StatsCard icon={LuUserCheck} label="Completed" value={status.completed || 0} />
            </div>


            <div className="border-b border-gray-200 mb-6 px-4">
              <nav className="flex space-x-8 border-b">
                {["All", "Completed", "Not Started", "In Progress"].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => this.setState({ tabName: tab })}
                    className={`pb-3 text-sm ${tabName === tab
                      ? "font-semibold border-b-2 border-black text-black"
                      : "font-medium textlight hover:text-gray-700"
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </nav>
            </div>

            {
              true ?
                <>
                  {/* Table Section*/}
                  <div className="overflow-x-auto bg-white border rounded-md p-4">
                    <div className="flex justify-between items-center mb-4">
                      <div className="flex items-center gap-2 text-sm textblack">
                        Show
                        <select value={this.state.size} onChange={this.handleSizeChange} className="border rounded-md px-2 py-1">
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </select>
                        entries
                      </div>

                      <div className="flex items-center gap-3 text-sm textblack">
                        <div className="">
                          <SearchBox
                            value={this.state.keyWord}
                            onChange={this.handleSearch}
                            placeholder="Search"
                          />
                        </div>
                        <div>{start}-{end} of {getMyUserTeamListTotal}</div>
                        <div onClick={this.goPrev} disabled={this.state.pageNo === 1} className={`p-2 rounded-md ${this.state.pageNo === 1 ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                          <MdArrowBackIos size={20} />
                        </div>
                        <div onClick={this.goNext} disabled={this.state.pageNo === totalPages} className={`p-2 rounded-md ${this.state.pageNo === totalPages ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                          <MdArrowForwardIos size={20} />
                        </div>
                      </div>
                    </div>

                    {compareUserList && compareUserList.length > 0 &&
                      <div className="border rounded-lg overflow-hidden p-2 mb-4">
                        <div className="flex flex-wrap gap-2">
                          {compareUserList.map((item, index) => (
                            <div key={index} className="flex items-center gap-3 px-3 py-1 bg-gray-50 border border-gray-300 rounded-md hover:shadow transition">
                              <span className="font-medium textblack text-sm">{item.name}</span>
                              <button onClick={() => this.selectCompareRow(item)} className="text-gray-600 hover:text-red-500 transition">✕</button>
                            </div>
                          ))}
                          <AddButton title="Compare Themes" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.openCompareTeamMemberModal} />
                        </div>
                      </div>}


                    <CommonTableTeamUsers
                      columns={columns}
                      data={data}
                      selectCompareRow={this.selectCompareRow}
                      compareEditable={compareEditable}
                      compareUserList={compareUserList}
                      getDimensionCodeCode={getDimensionCodeCode}
                      renderActions={(row) => (
                        <div className="flex gap-2">
                          <Tooltip text="Edit" position="top">
                            <div onClick={() => this.onEditUser(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600"><FiEdit size={18} /></div>
                          </Tooltip>
                          <Tooltip text="Delete" position="top">
                            <div onClick={() => this.onDeleteConfirm(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:text-red-600 hover:bg-red-200"><RiDeleteBinLine size={18} /></div>
                          </Tooltip>
                          <Tooltip text="Report" position="top">
                            {row.status === "Completed" ?
                              <div onClick={() => this.onReportModal(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600">
                                <TbReportAnalytics size={18} />
                              </div>
                              :
                              <div className="p-2 cursor-pointer rounded bg-gray-100 text-gray-300 hover:text-gray-600 hover:bg-gray-200">
                                <TbReportAnalytics size={18} />
                              </div>
                            }
                          </Tooltip>
                        </div>
                      )}
                    />

                    {this.state.keyWord || tabName !== "All" ?
                      <>
                        {!loading && !(data && data.length > 0) &&
                          <div className="flex items-center justify-center">
                            <div className="text-center py-8">
                              <div className="flex flex-col items-center justify-center text-gray-500">
                                <h1 className="text-lg font-semibold">No Data Found</h1>
                                <p className="text-sm mt-1">Try adjusting your search or filters</p>
                              </div>
                            </div>
                          </div>
                        }
                      </> :
                      <>
                        {!loading && !(data && data.length > 0) &&
                          <div className="bg-gradient-to-b from-blue-50 mt-4 to-white border rounded-xl min-h-[520px] flex flex-col items-center justify-center text-center space-y-6">
                            <div className="w-20 h-20 rounded-full bg-white border-4 border-[#E0F2F1] flex items-center justify-center">
                              <AiOutlineUsergroupAdd size={40} className="textcolor" />
                            </div>
                            <div className="space-y-1">
                              <h3 className="text-lg font-semibold">Add your first user to continue.</h3>
                              <p className="text-sm textlight">You can add users manually or upload a list.</p>
                            </div>
                            <AddButton title="Add New Member" Icon={HiMiniPlus} onClick={() => this.openAddTeamMemberModal()} className="bgcolor text-white" />
                          </div>
                        }

                      </>}

                  </div>
                </>

                :
                <>
                  {/* Empty State Card */}
                  <div className="bg-gradient-to-b from-teal-50 to-white border rounded-xl min-h-[520px] flex flex-col items-center justify-center text-center space-y-6">
                    <div className="w-20 h-20 rounded-full bg-white border-4 border-[#E0F2F1] flex items-center justify-center">
                      <AiOutlineUsergroupAdd size={40} className="textcolor" />
                    </div>
                    <div className="space-y-1">
                      <h3 className="text-lg font-semibold">Add team member from users to continue.</h3>
                      <p className="text-sm textlight">You can add users manually or upload a list.</p>
                    </div>
                    <AddButton title="Add New Member" Icon={HiMiniPlus} className="bgcolor text-white" />
                  </div>
                </>
            }

          </div>

          {addTeamMemberModal && (
            <AddTeamMembers onClose={this.closeAddTeamMembersModal}
              list={getMyUserTeamListData}
              total={getMyUserTeamListTotal}
              onSubmit={this.onAddTeamMember}
            />
          )
          }

          {compareTeamMemberModal && (
            <CompareTeamMembers
              onClose={this.closeCompareTeamMembersModal}
              getDimensionCodeCode={getDimensionCodeCode}
              list={getAllUserAssessmentByTeamIdData}
            />
          )}

          {updateUserModal && (
            <UpdateUserModal onClose={this.closeUpdateUserModal}
              updateForm={this.state.updateForm}
              handleUpdateChange={this.handleUpdateChange}
              onSubmit={this.onUpdateUser} />
          )}
          {
            updateUserModal && (
              <UpdateUserModal onClose={this.closeUpdateUserModal}
                updateForm={this.state.updateForm}
                handleUpdateChange={this.handleUpdateChange}
                onSubmit={this.onUpdateUser} />
            )
          }

          {
            showRemoveConfirmId && (
              <RemoveTeamMember onClose={this.closeDeleteConfirm} onSubmit={this.submitDeleteConfirm} />
            )
          }






          {(showReportModal || showSummaryReport || showManagerReportModal || showHiringReportModal) && (
            <div className="fixed inset-0 z-40 w-full h-screen bg-black bg-opacity-60 flex items-center justify-center">

              {/* Modal Box */}
              <div className="bg-white w-full max-w-6xl rounded-xl shadow-lg relative h-[90vh] flex flex-col">

                {/* Header */}
                <div className="flex items-center justify-center  relative shrink-0">
                  <h2 className="text-lg font-semibold text-center">
                    {/* TalentPlusStrenghts Report */}
                  </h2>

                  {/* Close Button */}
                  <button
                    onClick={this.closeModal}
                    className="absolute top-3 right-3 p-2 rounded-full hover:bg-gray-100 transition z-50"
                  >
                    <MdClose size={22} />
                  </button>
                </div>

                {/* Content (NO scroll here) */}
                <div className="flex-1 overflow-hidden">

                  <div className="w-full h-full scale-[0.95] origin-top">

                    {showReportModal && (
                      <AssessmentReport
                        closeReportModal={this.closeModal}
                        getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                        getAssessmenrEmployeeDetailsData={crrEmpDetails}
                        createdAt={createdAt}
                        EditButtonFn={EditButtonFn}
                        EditDetailsFn={EditDetailsFn}
                        loading={loading}
                        isUser={true}
                        surveyLanguageCode={surveyLanguageCode}
                      />
                    )}

                    {showSummaryReport && (
                      <AssessmentSummary
                        closeReportModal={this.closeModal}
                        getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                        getAssessmenrEmployeeDetailsData={crrEmpDetails}
                        createdAt={createdAt}
                        EditButtonFn={EditButtonFn}
                        EditDetailsFn={EditDetailsFn}
                        loading={loading}
                        isUser={true}
                        surveyLanguageCode={surveyLanguageCode}
                      />
                    )}

                    {showManagerReportModal && (
                      <AssessmentManagerReport
                        closeReportModal={this.closeModal}
                        getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                        getAssessmenrEmployeeDetailsData={crrEmpDetails}
                        createdAt={createdAt}
                        EditButtonFn={EditButtonFn}
                        EditDetailsFn={EditDetailsFn}
                        loading={loading}
                        isUser={true}
                        surveyLanguageCode={surveyLanguageCode}
                      />
                    )}

                    {showHiringReportModal && (
                      <AssessmentHiringReport
                        closeReportModal={this.closeModal}
                        getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                        getAssessmenrEmployeeDetailsData={crrEmpDetails}
                        createdAt={createdAt}
                        EditButtonFn={EditButtonFn}
                        EditDetailsFn={EditDetailsFn}
                        loading={loading}
                        isUser={true}
                        surveyLanguageCode={surveyLanguageCode}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}


        </Dashboard >

      </>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { assessment, questions } = state;
  return {
    loggingIn,
    assessment,
    questions
  };
}

export default connect(mapStateToProps)(AdminPanel);


